import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
// declare function MyToaster(msg,type): any;

@Injectable({
    providedIn: 'root'
})
export class AlertDialogService {
    constructor(private snackBar: MatSnackBar) { }
    openSnackBar(message: string, action: string) {
        if(action == '' || !action){
            action = "0";
        }
        // MyToaster(message, action);
        this.snackBar.open(message, action, {
            duration: 4000,
            // here specify the position
            verticalPosition: 'bottom'
        });
    }

    // openProjectSnackBar(message: string, action: string) {
    //     MyToaster(message, action);
    // }

}